import AddInstallContainer from "./AddInstallContainer";

export default AddInstallContainer;
